import { z } from "zod";

export const JobEquipmentRequirementSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().describe("Account"),
  job_id: z.string().uuid().describe("Job"),
  equipment_type_id: z.string().uuid().describe("Equipment Type"),
  quantity: z.number().int().describe("Quantity"),
  is_fulfilled: z.boolean().describe("Fulfilled"),
  notes: z.string().nullable().describe("Notes"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
});
export type JobEquipmentRequirement = z.infer<
  typeof JobEquipmentRequirementSchema
>;

export const JobEquipmentRequirementInsertSchema = z.object({
  job_id: z.string().uuid().describe("Job"),
  equipment_type_id: z.string().uuid().describe("Equipment Type"),
  quantity: z.number().int().min(1).default(1).describe("Quantity"),
  is_fulfilled: z.boolean().default(false).describe("Fulfilled"),
  notes: z.string().optional().describe("Notes"),
});

export const JobEquipmentRequirementUpdateSchema = z.object({
  quantity: z.number().int().min(1).optional().describe("Quantity"),
  is_fulfilled: z.boolean().optional().describe("Fulfilled"),
  notes: z.string().optional().describe("Notes"),
});

export const JobEquipmentRequirementQuerySchema = z.object({
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  job_id: z.string().uuid().optional(),
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  equipment_type_id: z.string().uuid().optional(),
  is_fulfilled: z
    .string()
    .transform((v) => v === "true")
    .optional(),
});
